import React, { useState } from "react";
import { PayoutsContext } from "./PayoutsContext";

interface IPayoutsProviderProps {
  children: React.ReactNode;
  convertCurrency?: any;
  onGenerateCurrentState?: () => void;
  paymentData?: any;
}

export const PayoutsProvider: React.FC<IPayoutsProviderProps> = ({
  children,
  convertCurrency = {},
  onGenerateCurrentState = () => {},
  paymentData = null,
}) => {
  const [showCreateUpdatePayout, setShowCreateUpdatePayout] = useState(false);
  const [dataCreateUpdatePayout, setDataCreateUpdatePayout] = useState<any>(null);

  return (
    <PayoutsContext.Provider value={{
      showCreateUpdatePayout,
      setShowCreateUpdatePayout,
      dataCreateUpdatePayout,
      setDataCreateUpdatePayout,
      convertCurrency,
      onGenerateCurrentState,
      paymentData,
    }}>
      {children}
    </PayoutsContext.Provider>
  );
};
